import React, { useEffect, useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { Nav, Tab } from "react-bootstrap";
import "./Equipments.css";
import Intermediat_Check from "./intermediat_Check/Intermediat_Check";
import Instrument_Check from "./instrument_Check/Instrument_Check";
import { useDispatch, useSelector } from "react-redux";
import { allInstrumentManagement } from "../../../../../../features/admin/common/Slice";

const Equipments = () => {
  const dispatch = useDispatch();
  const all_instruments = useSelector(
    (state) => state.common.all_instrument_management,
  );
  useEffect(() => {
    dispatch(allInstrumentManagement());
  }, [dispatch]);
  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Equipments" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="Intermediate_Check"
        >
          <Nav variant="pills" className="">
            <Nav.Item>
              <Nav.Link eventKey="Intermediate_Check">
                Intermediate Check
              </Nav.Link>
            </Nav.Item>

            <Nav.Item>
              <Nav.Link eventKey="Instrument_Check">Instrument Check</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Intermediate_Check">
              <Intermediat_Check all_instruments={all_instruments} />
            </Tab.Pane>

            <Tab.Pane eventKey="Instrument_Check">
              <Instrument_Check all_instruments={all_instruments}/>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Equipments;
